export const APP_LAYOUT = "AppLayout";
